import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'wl-image-card-button',
  templateUrl: './image-card-button.component.html',
  styleUrls: [
    './image-card-button.component.ed.scss',
    './image-card-button.component.essent.scss',
  ],
  standalone: true,
})
export class ImageCardButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title = '';

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() src?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() alt?: string;

  @Output()
  clicked = new EventEmitter<void>();

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() highlighted = false;
}
